import { useTranslation } from 'contexts/Localization'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import catFacePng from 'assets/vvsgotchi/moleDashGame/cat_face.png'
import { RetroText, GameOverFlex } from './styles'
import { MoleDashGameResult } from '../types'

const GameOverTexts: React.FC<{ gameResult: MoleDashGameResult }> = ({ gameResult }) => {
  const { t } = useTranslation()

  return (
    <GameOverFlex>
      {gameResult?.newRecord ? (
        <>
          <RetroText fontSize="24px">{t('New Record')}</RetroText>
          <PixelatedImage src={catFacePng} width="100px" mt={2} />
        </>
      ) : (
        <>
          <RetroText fontSize="24px">{t('Game Over')}</RetroText>
          <RetroText fontSize="24px">{t('(´o`)')}</RetroText>
        </>
      )}
    </GameOverFlex>
  )
}

export default GameOverTexts
